<div id="floating-progress" *ngIf="title">
  <div id="floating-content-cont">
    <div *ngIf="icon">
      <mat-icon>{{icon}}</mat-icon>
    </div>
    <div id="floating-content-title">
      <div>{{ title | translate }}</div>
      <div>
        <mat-progress-bar
          [mode]="max ? 'determinate':'indeterminate'"
          [value]="((curr || 0) / (max || 1)) * 100"></mat-progress-bar>
      </div>
    </div>
  </div>
</div>
